export default __webpack_public_path__ + "static/implementation-afda68cbddec2f6796f70c15e3d6ed6c.png";